import { render, staticRenderFns } from "./table_form.vue?vue&type=template&id=d040d4f4&scoped=true"
import script from "./table_form.vue?vue&type=script&lang=js"
export * from "./table_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d040d4f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d040d4f4')) {
      api.createRecord('d040d4f4', component.options)
    } else {
      api.reload('d040d4f4', component.options)
    }
    module.hot.accept("./table_form.vue?vue&type=template&id=d040d4f4&scoped=true", function () {
      api.rerender('d040d4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/target/form/components/table_form.vue"
export default component.exports